import React, { useState } from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

import ProspectEnrichmentForm from '../../components/savvydata/ProspectEnrichmentForm.tsx';
import ProspectAnalytics from '../../components/savvydata/ProspectAnalytics.tsx';
import SavvyDataSolutionDetail from '../../components/savvydata/SavvyDataSolutionDetail.tsx';
import { Prospect } from '../../types/savvydata.ts';

const ContentContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  overflow: 'auto',
  padding: theme.spacing(3),
}));

interface SavvyDataDemoContentProps {
  onBack?: () => void;
}

// Define the demo states as a regular object instead of an enum to avoid linter warnings
const DemoStates = {
  PROSPECT_FORM: 'PROSPECT_FORM',
  PROSPECT_ANALYTICS: 'PROSPECT_ANALYTICS',
  SOLUTION_DETAIL: 'SOLUTION_DETAIL'
} as const;

// Type for the state
type DemoStateType = typeof DemoStates[keyof typeof DemoStates];

const SavvyDataDemoContent: React.FC<SavvyDataDemoContentProps> = ({ onBack }) => {
  const [demoState, setDemoState] = useState<DemoStateType>(DemoStates.PROSPECT_FORM);
  const [prospect, setProspect] = useState<Prospect | null>(null);
  const [hasProposal, setHasProposal] = useState(false);
  
  const handleProspectEnriched = (enrichedProspect: Prospect) => {
    setProspect(enrichedProspect);
    setDemoState(DemoStates.PROSPECT_ANALYTICS);
  };
  
  const handleGenerateProposal = () => {
    setDemoState(DemoStates.SOLUTION_DETAIL);
    setHasProposal(true);
  };
  
  const handleAddProposalToEmail = () => {
    setDemoState(DemoStates.PROSPECT_ANALYTICS);
  };
  
  const handleBack = () => {
    if (demoState === DemoStates.PROSPECT_ANALYTICS) {
      setDemoState(DemoStates.PROSPECT_FORM);
    } else if (demoState === DemoStates.SOLUTION_DETAIL) {
      setDemoState(DemoStates.PROSPECT_ANALYTICS);
    } else if (onBack) {
      onBack();
    }
  };
  
  return (
    <ContentContainer>
      <Typography variant="h4" sx={{ color: '#fff', mb: 3 }}>
        SavvyData Marketing Platform Demo
      </Typography>
      
      <Divider sx={{ mb: 3, borderColor: 'rgba(138, 43, 226, 0.2)' }} />
      
      {demoState === DemoStates.PROSPECT_FORM && (
        <ProspectEnrichmentForm onProspectEnriched={handleProspectEnriched} />
      )}
      
      {demoState === DemoStates.PROSPECT_ANALYTICS && prospect && (
        <ProspectAnalytics 
          prospect={prospect} 
          onGenerateProposal={handleGenerateProposal}
          hasProposal={hasProposal}
        />
      )}
      
      {demoState === DemoStates.SOLUTION_DETAIL && (
        <SavvyDataSolutionDetail 
          onBack={handleBack} 
          onAddToEmail={handleAddProposalToEmail}
        />
      )}
    </ContentContainer>
  );
};

export default SavvyDataDemoContent;